import React, { lazy, Suspense } from 'react';

const LazyOrderHistoryPop = lazy(() => import('./OrderHistoryPop'));

const OrderHistoryPop = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyOrderHistoryPop {...props} />
  </Suspense>
);

export default OrderHistoryPop;
